module.exports = __webpack_public_path__ + "static/media/talita.0620b532.png";